import { getTourCompleteList } from "../../../data/repository/tour.repo";

export const GetTourCompleteListUseCase = async () => {
  try {
    const resp = await getTourCompleteList();
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
